/* eslint-disable @typescript-eslint/no-unused-vars */
import images from "../../constants/images";

import {
  codamCodingCollegeDescription2,
  codamCodingCollegeDescription3,
  codamCodingCollegeDescription4,
  codamCodingCollegeDescription5,
  codamCodingCollegeDescription6,
  idealPaymentsDescription1,
  idealPaymentsDescription2,
  idealPaymentsDescription3,
  agileProductManagementDescription1,
  agileProductManagementDescription2,
  infoEmergingIndustriesDescription1,
  infoEmergingIndustriesDescription2,
  takeawayPointsDescription1,
  takeawayPointsDescription2,
  takeawayPointsDescription3,
  takeawayPointsDescription4,
  takeawayPointsDescription5,
  takeawayPointsDescription6,
  hanUniversityDescription1,
  hanUniversityDescription2,
  hanUniversityDescription3,
  hanUniversityDescription4,
  hanUniversityDescription5,
  hanUniversityDescription6,
  lloydsEchoDescription,
  babbelLanguageDescription1,
  babbelLanguageDescription2,
  babbelLanguageDescription3,
  babbelLanguageDescription4,
  unknownUniDescription,
  codamProfessionalDevelopment1,
  codamProfessionalDevelopment2,
  codamProfessionalDevelopment3,
  codamProfessionalDevelopment4,
  codamProfessionalDevelopment5,
  codamProfessionalDevelopment6,
  chapterWorksDescription1,
  chapterWorksDescription2,
  chapterWorksDescription3,
  chapterWorksDescription4,
  chapterWorksDescription5,
  kfcDescription1,
  kfcDescription2,
  kfcDescription3,
  kfcDescription4,
} from "./projects-text";

import chapterAnimation1 from "../../assets/lottie-animations/chapter_animation.json";
import chapterAnimation2 from "../../assets/lottie-animations/chapter-app-animation.json";

const {
  codamImg,
  idealImg,
  agileImg,
  tkwyImg,
  infoImg,
  hanImg,
  lloydsImg,
  codamV2Img,
  babbelTwo,
  gs4e1,
  gs4e2,
  gs4e3,
  unknown1,
  unknown2,
  unknown3,
  u,
  u2,
  u34,
  u4,
  infoOffice,
  codamNightTime,
  hanStudent,
  surfCatalog1,
  surfCatalog2,
  idealPayments1,
  idealPayments2,
  thuisebezord2,
  thuisbezorgd3,
  thuisbezorgd4,
  thuisbezorgd6,
  codamV1Img,
  codamV3Img,
  babbel1,
  babbel2,
  babbel3,
  babbel4,
  babbel5,
  babbel6,
  babbel7,
  babbel8,
  stripeScreen,
  chapterLogo,
  chapterAppPallette,
  chapterAppPresentation,
  kfc3,
  kfc5,
  kfc6,
  kfc7,
  kfc8,
} = images;

const codamProject = {
  video: false,
  image: {
    value: codamImg,
    alt: "Codam Coding University",
  },
  title: "Student Coding Mentoring",
  description:
    "Mentoring and serving the next generation of software engineers @ Codam Coding College.",
  longDescription2: codamCodingCollegeDescription2,
  longDescription3: codamCodingCollegeDescription3,
  longDescription4: codamCodingCollegeDescription4,
  longDescription5: codamCodingCollegeDescription5,
  longDescription6: codamCodingCollegeDescription6,
  link: {
    href: "https://www.codam.nl/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Codam University.",
    pageIdentifier: "/projects-codam",
  },
  extendedData: {
    images: {
      nighTime: {
        value: codamNightTime,
        alt: "Codam University At Night Time",
      },
    },
  },
};

const idealProject = {
  video: true,
  image: {
    value: idealImg,
    alt: "Ideal Payments",
  },
  title: "Ideal Payments Integration",
  description:
    "Integrating the iDEAL payments network for online banking at Nationale Nederlanden.",
  longDescription1: idealPaymentsDescription1,
  longDescription2: idealPaymentsDescription2,
  longDescription3: idealPaymentsDescription3,
  link: {
    href: "https://www.ideal.nl/en/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about the iDEAL protocol.",
    pageIdentifier: "/projects-ideal",
  },
  extendedData: {
    images: {
      banksList: {
        value: idealPayments2,
        alt: "iDEAL issuers list",
      },
      idealOnline: {
        value: idealPayments1,
        alt: "iDEAL online",
      },
    },
  },
};

const agileProjectManagementProject = {
  video: true,
  image: {
    value: agileImg,
    alt: "Agile Project Management",
  },
  title: "Agile Project Management",
  description:
    "Explaining the concept of Agile Project Management & Software Delivery.",
  longDescription1: agileProductManagementDescription1,
  longDescription2: agileProductManagementDescription2,
  link: {
    href: "https://info.nl/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Info Agency.",
    pageIdentifier: "/projects-agile",
  },
  extendedData: {
    images: {
      office: {
        value: infoOffice,
        alt: "INFO office",
      },
    },
  },
};

const chapterProject = {
  title: "AI Chatbot Assistant",
  video: false,
  image: {
    value: chapterAppPallette,
    alt: "Chapter logo",
  },
  description: chapterWorksDescription1,
  longDescription1: chapterWorksDescription2,
  longDescription2: chapterWorksDescription4,
  longDescription3: chapterWorksDescription3,
  longDescription4: chapterWorksDescription5,
  link: {
    href: "https://www.chapter.works/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Chapter.",
    pageIdentifier: "/projects-chapter",
  },
  extendedData: {
    animations: {
      one: chapterAnimation1,
      two: chapterAnimation2,
    },
    images: {
      chapterAppPallette: { value: chapterAppPallette, alt: "Chapter App 1" },
      chapterAppPresentation: {
        value: chapterAppPresentation,
        alt: "Chapter App Two",
      },
    },
  },
};

const takeawayProject = {
  video: false,
  image: {
    value: tkwyImg,
    alt: "Takeaway.com & JustEat.com",
  },
  title: "Loyalty Points Platform",
  description:
    "Providing Just Eat & Takewaway customers with loyalty points for their online food purchases.",
  longDescription1: takeawayPointsDescription1,
  longDescription2: takeawayPointsDescription2,
  longDescription3: takeawayPointsDescription3,
  longDescription4: takeawayPointsDescription4,
  longDescription5: takeawayPointsDescription5,
  longDescription6: takeawayPointsDescription6,
  link: {
    href: "https://www.thuisbezorgd.nl/en/punten",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about TakeAway.com & Takeaway Punten.",
    pageIdentifier: "/projects-takeaway",
  },
  extendedData: {
    images: {
      hero: {
        value: thuisebezord2,
        alt: "Thuisbezorgd meal",
      },
      meeting: {
        value: thuisbezorgd4,
        alt: "Thuisbezorgd meeting",
      },
      app1: {
        value: thuisbezorgd3,
        alt: "Thuisbezorgd app screen 1",
      },
      app2: { value: thuisbezorgd6, alt: "Thuisbezorgd app screen 2" },
    },
  },
};

const infoEmergingIndustriesProject = {
  video: true,
  image: {
    value: infoImg,
    alt: "Emerging Industries",
  },
  title: "Emerging Industries",
  description:
    "Exploring the definition of technology within Emerging Industries at Info Business Innovation Partner.",
  longDescription1: infoEmergingIndustriesDescription1,
  longDescription2: infoEmergingIndustriesDescription2,
  link: {
    href: "https://info.nl/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Info Agency.",
    pageIdentifier: "/projects-emerging-industries",
  },
};

const hanUniversityProject = {
  video: false,
  image: {
    value: hanImg,
    alt: "HAN Open Science Platform",
  },
  title: "HAN Open Science Platform",
  description:
    "Providing a research platform tool for students and industry experts at Han University.",
  longDescription1: hanUniversityDescription1,
  longDescription2: hanUniversityDescription2,
  longDescription3: hanUniversityDescription3,
  longDescription4: hanUniversityDescription4,
  longDescription5: hanUniversityDescription5,
  longDescription6: hanUniversityDescription6,
  link: {
    href: "https://han-front-production.azurewebsites.net/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about the HAN platform.",
    pageIdentifier: "/projects-han",
  },
  extendedData: {
    images: {
      mainStudent: {
        value: hanStudent,
        alt: "HAN student",
      },
      catalog1: { value: surfCatalog1, alt: "SURF Catalog One" },
      catalog2: { value: surfCatalog2, alt: "SURF Catalog Two" },
    },
  },
};

const lloydsEchoProject = {
  video: true,
  image: {
    value: lloydsImg,
    alt: "Lloyds Bank & Amazon Echo",
  },
  title: "Lloyds Bank & Amazon Echo",
  description:
    "Voice Controlled Online Banking @ Lloyds Banking Group Using The Amazon Echo.",
  longDescription: lloydsEchoDescription,
  link: {
    href: "https://www.lloydsbank.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Lloyds Bank.",
    pageIdentifier: "/projects-lloyds",
  },
};

const codamProjectV2 = {
  video: false,
  image: {
    value: codamV2Img,
    alt: "Codam Coding University",
  },
  title: "Professional Development",
  description:
    "Setting up grduating software engineers for success in their careers.",
  longDescription1: codamProfessionalDevelopment1,
  longDescription2: codamProfessionalDevelopment2,
  longDescription3: codamProfessionalDevelopment3,
  longDescription4: codamProfessionalDevelopment4,
  longDescription5: codamProfessionalDevelopment5,
  longDescription6: codamProfessionalDevelopment6,
  link: {
    href: "https://www.codam.nl/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Codam University.",
    pageIdentifier: "/projects-codam",
  },
  extendedData: {
    images: {
      birdsEyeView: {
        value: codamV3Img,
        alt: "Codam coding college birds eye view",
      },
      teaching: {
        value: codamV1Img,
        alt: "Ashley teaching students",
      },
    },
  },
};

const babbelProject = {
  video: false,
  image: {
    value: babbelTwo,
    alt: "Babbel",
  },
  title: "Babbel Subscriptions",
  description:
    "Babbel educational technology teaches you a new language - you decide where it takes you.",
  longDescription1: babbelLanguageDescription1,
  longDescription2: babbelLanguageDescription2,
  lomgDescription3: babbelLanguageDescription3,
  longDescription4: babbelLanguageDescription4,
  link: {
    href: "https://babbel.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Babbel.",
    pageIdentifier: "/projects-babbel",
  },
  extendedData: {
    images: {
      appScreen1: { value: babbel6, alt: "App screen one" },
      appScreen2: { value: babbel7, alt: "App screen two" },
      appScreen3: { value: babbel8, alt: "App screen three" },
      appScreen4: { value: babbel4, alt: "App screen four" },
      stripeScreen: { value: stripeScreen, alt: "Stripe screen" },
    },
  },
};

const unknownUniProject = {
  video: false,
  image: {
    value: u4,
    alt: "Unknown University Of Applied Sciences",
  },
  title: "Unknown University Of Applied Sciences",
  description: "Become an entrepreneur by being one.",
  longDescription: unknownUniDescription,
  link: {
    href: "https://unknown-university.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about Unknown University.",
    pageIdentifier: "/projects-unknown-university",
  },
};

const kfcProject = {
  video: false,
  image: {
    value: kfc6,
    alt: "KFC",
  },
  title: "KFC Menu Generation",
  description:
    "Generating dynamic KFC menus for restaurants, kiosks and food delivery apps.",
  longDescription1: kfcDescription1,
  longDescription2: kfcDescription2,
  longDescription3: kfcDescription3,
  longDescription4: kfcDescription4,
  link: {
    href: "https://www.yum.com/wps/portal/yumbrands/Yumbrands/company/our-brands/kfc",
    target: "_blank",
    rel: "noopener noreferrer",
    value: "Learn more about KFC.",
    pageIdentifier: "/projects-kfc",
  },
  extendedData: {
    images: {
      kiosk1: { value: kfc3, alt: "Kfc kiosk 1" },
      kiosk2: { value: kfc5, alt: "Kfc kiosk 2" },
      brands: { value: kfc8, alt: "Kfc kiosk 3" },
      advert: { value: kfc7, alt: "Kfc advert" },
    },
  },
};

export {
  codamProject,
  idealProject,
  infoEmergingIndustriesProject,
  agileProjectManagementProject,
  takeawayProject,
  hanUniversityProject,
  lloydsEchoProject,
  codamProjectV2,
  babbelProject,
  unknownUniProject,
  chapterProject,
  kfcProject,
};
